import type { Organization } from '@upright/common/iam/organizations/organization-types';
import { isDmaOrg } from '@upright/common/utils';

/**
 * Who the DMA dashboard (`/dashboard`, the "Private workspace") opens for: team users, and users of
 * a DMA Freemium or DMA Consultant organisation. Everyone else is sent back to `/`, whatever their
 * organisation's own company or their access to its DMA.
 *
 * One rule for the dashboard and for the unified top bar's workspace pill that leads to it
 * (PLT-7986), so the pill is never offered to someone the dashboard turns away.
 */
export function canOpenDmaDashboard(args: { isTeam: boolean; organization: Organization | undefined }): boolean {
  return args.isTeam || isDmaOrg(args.organization);
}
